import React from "react";
import { Box } from "@mui/material";

const Logo = ({ height = "100%", width = "auto", alt = "logo" }) => {
  const logoSrc = "/images/logos/banilux_logo.png";
  return (
    <Box
      sx={{
        display: "grid",
        placeItems: "center",
        margin: "0.25rem",
        width: "auto",
        height: "auto",
        overflow: "hidden",
      }}
    >
      <img
        src={logoSrc}
        alt={alt}
        style={{
          height: height,
          width: width,
          maxWidth: "100%",
          objectFit: "contain",
        }}
      />
    </Box>
  );
};

export default Logo;
